module.exports = __webpack_public_path__ + "files/71a98abe7241ef395c4e71973c48c462.png";